import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import { follow, unfollow } from 'bundles/discussions/actions/ThreadDetailsActions';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/Follow';

class Follow extends React.Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof Follow.contextTypes>;

  toggleFollowing = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'question' does not exist on type 'Readon... Remove this comment to see the full error message
    const { question } = this.props;

    if (question.isFollowing) {
      this.context.executeAction(unfollow, { question });
    } else {
      this.context.executeAction(follow, { question });
    }
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'question' does not exist on type 'Readon... Remove this comment to see the full error message
    const { isFollowing, followError } = this.props.question;

    return (
      <button className="rc-Follow" onClick={this.toggleFollowing} aria-pressed={isFollowing}>
        <span>{isFollowing ? _t('Unfollow this discussion') : _t('Follow this discussion')} </span>
        {followError && <span>{_t('Sorry, something went wrong')}</span>}
      </button>
    );
  }
}

export default Follow;
